import { baseUrl } from './base';
import ajax from '@/common/ajax';
import qs from 'qs';

const home = {
    /**
     * 登录接口
     */
    loginUser(param){
        return ajax.get(`${baseUrl}service/experience?cmd=exp_status&${qs.stringify(param)}`);
    },
    /**
     * 登录态接口
     */
    loginStatus(param){
        return ajax.post(`${baseUrl}service/experience?${qs.stringify(param)}`)
    },
    /**
     * 账号申请
     */
    uinApply(param){
        return ajax.get(`${baseUrl}service/experience?cmd=exp_apply&${qs.stringify(param)}`)
    },
    /**
     * 发送账密 
     */
    sendemail(param){
        return ajax.get(`${baseUrl}service/experience?cmd=exp_sendemail&${qs.stringify(param)}`)
    },
    /**
     * 获取验证码
     */
    getCount(param){
        return ajax.get(`${baseUrl}get_code`)
    }
}

export default home;